import React, { useEffect, useState } from "react";
import AppDataTable from "./AppDataTable";
import { getAllowClient } from "../../interpreter/clients";
import Icon from '@mdi/react';
import { mdiLockReset , mdiInformationOutline , mdiEmailFastOutline } from '@mdi/js';

export const ClientList = ({ clients,setClients, openModal }) => {
  // Definir columnas para DataTable
  // Cargar clientes desde GraphQL
  const [loading, setLoading] = useState(true);
    useEffect(() => {
      const fetchClients = async () => {
        setLoading(true);
        try {
          const response = await getAllowClient();
          if (response?.result) {
            setClients(response.clients_content || []);
          } else {
            console.warn("No se encontraron clientes.");
          }
        } catch (error) {
          console.warn("Error al cargar los clientes.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchClients();
    }, []);
  

  const columns = [
    { name: "Código", selector: row => row.id_clientInternal, sortable: true, width: "80px" },
    { name: "Nombre y Apellido", selector: row => row.full_name, sortable: true },
    { name: "Teléfono", selector: row => row.phoneNumber, sortable: true },
    { name: "Email", selector: row => row.email },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="flex flex-row space-x-2">
          <button
            onClick={() => openModal('reset', row)}
            className="bg-red-500 hover:bg-red-600 text-white text-sm py-1 px-2 rounded flex items-center justify-center gap-2 w-full"
          ><Icon path={mdiLockReset} size={1.2} />
          </button>
          <button
            onClick={() => openModal('data', row)}
            className="bg-blue-500 hover:bg-blue-600 text-white text-sm py-1 px-2 rounded flex items-center justify-center gap-2 w-full"
          ><Icon path={mdiInformationOutline} size={1.2}/>
          </button>

        </div>
      ),
      width: "200px",
    },
  ];

  // Estilos personalizados para DataTable
  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "#f3f4f6",
        padding: "12px",
        fontSize:"15px"
      },
    },
    cells: {
      style: {
        textAlign: "center",
        justifyContent: "center",
        minHeight: "60px",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontSize:"13.5px",
      },
    },
  };

  return (
    <div>
    {loading ? (
      // ✅ Spinner animado con Tailwind CSS (sin consumir recursos)
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
      </div>
    ) : (
        <AppDataTable
          columns={columns}
          data={clients}
          scrollHeight="500px"
          customStyles={customStyles}
        />
      )}
  </div>
  );
};
